/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, {
    useState,
    useRef,
    useEffect,
} from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Swal from 'sweetalert2';
import Grid from '@material-ui/core/Grid';
import BuscaForm from '../../gww-lib/busca-no-form/index';
import validaCPF from '../../../tools/validacoes/cpf';
import validaCNPJ from '../../../tools/validacoes/cnpj';
import validaEmail from '../../../tools/validacoes/email';
import CampoTextoAjuda from '../../gww-lib/campo-texto-ajuda';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import dbToBoolean from '../../../tools/dbToBoolean';

// Mascaras
import MascaraTelefone from '../../../tools/mascaras/telefone';
import MascaraCPF from '../../../tools/mascaras/cpf';
import MascaraCNPJ from '../../../tools/mascaras/cnpj';


import api from '../../../services/api';
import consultaApi from '../../../services/consultaApi';
import { withRouter, useHistory } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    controlaTitulo: {
        paddingTop: 30,
        paddingBottom: 12,
        fontSize: "2em",
    },
    corDoFundo: {
        backgroundColor: "#f1f1f1",
        paddingBottom: 30,
    },
    controlaCard: {
        textAlign: "center",
        padding: theme.spacing(2),
    },
    formControl: {
        marginBottom: 8,
        width: "100%",
    },
    ocultaCampo: {
        display: "none",
    },
    botaoRodape: {
        padding: theme.spacing(1),
    },
    endereco: {
        padding: theme.spacing(1),
        marginBottom: 8,
        width: '100%'
    },
    tituloTexto: {
        fontSize: '1.2rem'
    },
    textField: {
        marginBottom: 8,
    }
}))

function FormPessoa(props) {


    const pessoaTemp = props.pessoa;

    const classes = useStyles();

    // States Campos
    const [codigoPessoa] = useState(pessoaTemp.CCDPESS ? pessoaTemp.CCDPESS : 0);
    const [cpf, setCpf] = useState(pessoaTemp.CCPF ? pessoaTemp.CCPF : '');
    const [cnpj, setCnpj] = useState(pessoaTemp.CNPJ ? pessoaTemp.CNPJ : '');
    const [passaporte, setPassaporte] = useState(pessoaTemp.CPASSAPORTE ? pessoaTemp.CPASSAPORTE : '');
    const [ie, setIe] = useState(pessoaTemp.CIE ? pessoaTemp.CIE : '');
    const [fantasia, setFantasia] = useState(pessoaTemp.CDSPESS ? pessoaTemp.CDSPESS : '');
    const [razao, setRazao] = useState(pessoaTemp.CRZPESS ? pessoaTemp.CRZPESS : '');
    const [cep, setCep] = useState(pessoaTemp.CCEP ? pessoaTemp.CCEP : '');
    const [rua, setRua] = useState(pessoaTemp.CRUA ? pessoaTemp.CRUA : '');
    const [numero, setNumero] = useState(pessoaTemp.NR ? pessoaTemp.NR : '');
    const [bairro, setBairro] = useState(pessoaTemp.CBAIRRO ? pessoaTemp.CBAIRRO : '');
    const [codigoCidade, setCodigoCidade] = useState(pessoaTemp.CCDCIDADE ? pessoaTemp.CCDCIDADE : '');
    const [descricaoCidade, setDescricaoCidade] = useState(pessoaTemp.CDSCIDADE ? pessoaTemp.CDSCIDADE : '');
    const [complemento, setComplemento] = useState(pessoaTemp.COMPLEMENTO ? pessoaTemp.COMPLEMENTO : '');
    const [email, setEmail] = useState(pessoaTemp.CEMAIL ? pessoaTemp.CEMAIL : '');
    const [telefone, setTelefone] = useState(pessoaTemp.CFONE ? pessoaTemp.CFONE : '');
    const [tipoPessoa, setTipoPessoa] = useState(pessoaTemp.CPESSOA ? pessoaTemp.CPESSOA : 'J');
    const [tipoIe, setTipoIe] = useState(pessoaTemp.NINDIEDEST ? pessoaTemp.NINDIEDEST : 1);
    const [ativo, setAtivo] = useState(pessoaTemp.CCDPESS > 0 ? dbToBoolean(pessoaTemp.LATIVO) : true);
    // States Erros
    const [cpfErro, setCpfErro] = useState(false);
    const [cpfErroTexto, setCpfErroTexto] = useState();
    const [cnpjErro, setCnpjErro] = useState(false);
    const [cnpjErroTexto, setCnpjErroTexto] = useState();
    const [passaporteErro, setPassaporteErro] = useState(false);
    const [passaporteErroTexto, setPassaporteErroTexto] = useState();
    const [ieErro] = useState(false);
    const [ieErroTexto] = useState();
    const [fantasiaErro, setFantasiaErro] = useState(false);
    const [fantasiaErroTexto, setFantasiaErroTexto] = useState();
    const [razaoErro, setRazaoErro] = useState(false);
    const [razaoErroTexto, setRazaoErroTexto] = useState();
    const [cepErro, setCepErro] = useState(false);
    const [cepErroTexto, setCepErroTexto] = useState();
    const [ruaErro, setRuaErro] = useState(false);
    const [ruaErroTexto, setRuaErroTexto] = useState();
    const [numeroErro, setNumeroErro] = useState(false);
    const [numeroErroTexto, setNumeroErroTexto] = useState();
    const [bairroErro, setBairroErro] = useState(false);
    const [bairroErroTexto, setBairroErroTexto] = useState();
    const [cidadeErro, setCidadeErro] = useState(false);
    const [cidadeErroTexto, setCidadeErroTexto] = useState();
    const [complementoErro] = useState(false);
    const [complementoErroTexto] = useState();
    const [emailErro, setEmailErro] = useState(false);
    const [emailErroTexto, setEmailErroTexto] = useState();
    const [telefoneErro] = useState(false);
    const [telefoneErroTexto] = useState();
    const [tipoPessoaErro, setTipoPessoaErro] = useState(false);
    const [tipoPessoaErroTexto, setTipoPessoaErroTexto] = useState();
    const [tipoIeErro, setTipoIeErro] = useState(false);
    const [tipoIeErroTexto, setTipoIeErroTexto] = useState();
    // States Labels
    const [labelNome, setLabelNome] = useState("Nome");
    const inputLabel = useRef(null);
    const inputLabelIE = useRef(null);
    const [labelWidth, setLabelWidth] = useState(0);
    const [labelWidthIE, setLabelWidthIE] = useState(0);

    const history = useHistory();

    const refCNPJ = useRef(null);
    const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop);

    let camposErrados;

    useEffect(() => {
        setLabelWidth(inputLabel.current.offsetWidth);
        setLabelWidthIE(inputLabelIE.current.offsetWidth);
    }, []);

    useEffect(() => {
        if (tipoPessoa !== 'J') {
            setLabelNome("Nome");
        } else {
            setLabelNome("Fantasia");
        }

        if (tipoPessoa === 'J') {
            setCpf('');
        } else if (tipoPessoa === 'F') {
            setCnpj('');
        } else {
            setCnpj('');
            setCpf('');
        }

    }, [tipoPessoa]);

    useEffect(() => {
        if (tipoPessoa === 'F') {
            if (ie != '' && ie != 0) {
                setTipoIe(1);
            } else {
                setTipoIe(9);
            }
        } else if (tipoPessoa === 'J') {
            if (ie != '' && ie != 0) {
                setTipoIe(1);
            } else {
                setTipoIe(2);
            }
        } else {
            setTipoIe(9);
        }
    }, [tipoPessoa, ie])

    useEffect(() => {
        if (tipoPessoa == 'F') {
            setRazao(fantasia);
        }
    }, [fantasia])

    useEffect(() => {
        if (pessoaTemp.CCEP !== cep) {
            if (cep.length === 8) {
                buscarPorCep(cep);
            }
        }
    }, [cep])

    const handleChange = event => {
        setTipoPessoa(event.target.value);
    };

    const handleChangeIE = event => {
        setTipoIe(event.target.value);
    };

    async function buscarPorCep(cep) {
        const retorno = await api.get(`https://viacep.com.br/ws/${cep}/json/`);
        setCepErro(false);
        setCepErroTexto('');
        if (retorno.data.erro) {
            setRua('');
            setBairro('');
            setCodigoCidade('');
            setCepErro(true);
            setCepErroTexto('Cep inexistente na base nacional.');
        } else {
            setRua(retorno.data.logradouro);
            setBairro(retorno.data.bairro);
            setCodigoCidade(retorno.data.ibge);
            setDescricaoCidade(retorno.data.localidade.toUpperCase());
        }

    }

    function cancelar() {
        Swal.fire({
            type: 'question',
            title: 'Cancelar ?',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            showLoaderOnConfirm: true,
            preConfirm: (result) => {
                if (result) {
                    vaiListagem()
                }
            },
        });
        // 
    }

    function vaiListagem() {
        history.push('/pessoa');
    }

    async function salvar(e) {
        e.preventDefault();
        if (validaCampos()) {
            Swal.fire({
                type: 'question',
                title: 'Salvar Pessoa ?',
                showCancelButton: true,
                confirmButtonText: 'Salvar',
                cancelButtonText: 'Cancelar',
                showLoaderOnConfirm: true,
                preConfirm: (result) => {
                    return new Promise(async (resolve, reject) => {
                        let dadosPessoa = {
                            PROCNAME: "WEBSITE_GPESSOA_L_ADD",
                            PCCDPESS: codigoPessoa,
                            PCPESSOA: tipoPessoa.toUpperCase(),
                            PCRZPESS: razao ? razao.toUpperCase() : fantasia.toUpperCase(),
                            PCDSPESS: fantasia.toUpperCase(),
                            PCNPJ: cnpj,
                            PCIE: tipoIe != 1 ? 0 : ie,
                            PCCPF: cpf,
                            PCRUA: rua.toUpperCase(),
                            PNR: numero,
                            PCBAIRRO: bairro.toUpperCase(),
                            PCCDCIDADE: codigoCidade,
                            PCOMPLEMENTO: complemento.toUpperCase(),
                            PCFONE: telefone,
                            PCCEP: cep,
                            PCEMAIL: email.toUpperCase(),
                            PNINDIEDEST: tipoIe,
                            PLCONSUMIDORFINAL: 1,
                            PCPASSAPORTE: passaporte,
                            PCELULAR: telefone,
                            PLATIVO: ativo ? 1 : 0,
                        };

                        let resposta = await consultaApi(dadosPessoa);

                        resolve(resposta.data);
                    });

                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if (result.value) {
                    if (result.value.CODIGO_ERRO == 0) {
                        Swal.fire({
                            type: 'success',
                            html: result.value.MENSAGEM_RESPOSTA,
                        });
                        vaiListagem();
                    } else {
                        Swal.fire({
                            type: 'error',
                            html: result.value.MENSAGEM_RESPOSTA,
                        });
                    }
                }
            });
        } else {
            Swal.fire({
                type: 'error',
                title: 'Campos Inválidos',
                html: `<lu>` +
                    camposErrados.map(campoErrado => (
                        `<li>${campoErrado}</li>`
                    )) +
                    `</lu>`
            })
        }

    }

    function validaCampos() {
        camposErrados = [];

        if (tipoPessoa === 'F') {
            if (cpf === '') {
                setCpfErro(true);
                setCpfErroTexto('Por favor preencha o CPF.');
                camposErrados.push("CPF");
            } else if (!validaCPF(cpf)) {
                setCpfErro(true);
                setCpfErroTexto('CPF Inválido!');
                camposErrados.push("CPF");
            } else {
                setCpfErro(false);
            }
        }

        if (tipoPessoa === 'J') {
            if (cnpj === '') {
                setCnpjErro(true);
                setCnpjErroTexto("Por favor preencha o CNPJ.");
            } else if (!validaCNPJ(cnpj)) {
                setCnpjErro(true);
                setCnpjErroTexto("CNPJ inválido!");
                scrollToRef(refCNPJ);
                camposErrados.push("CNPJ");
            } else {
                setCnpjErro(false);
            }

            if (razao === '') {
                setRazaoErro(true);
                setRazaoErroTexto("Por favor preencha a razão");
                camposErrados.push("Razão Social");
            } else {
                setRazaoErro(false);
            }
        }

        if (tipoPessoa === 'E') {
            if (passaporte === '') {
                setPassaporteErro(true);
                setPassaporteErroTexto("Por favor preencha o passaporte.");
                camposErrados.push("Passaporte");
            } else {
                setPassaporteErro(false);
            }
        }

        if (fantasia === '') {
            setFantasiaErro(true);
            setFantasiaErroTexto(`Por favor preencha ${labelNome}`)
            camposErrados.push(labelNome)
        } else {
            setFantasiaErro(false);
        }

        if (cep === '') {
            setCepErro(true);
            setCepErroTexto("Por favor preencha o CEP");
            camposErrados.push("CEP");
        } else {
            setCepErro(false);
        }

        if (rua === '') {
            setRuaErro(true);
            setRuaErroTexto("Por favor preencha Rua");
            camposErrados.push("Rua");
        } else {
            setRuaErro(false);
        }

        if (numero === '') {
            setNumeroErro(true);
            setNumeroErroTexto("Por favor preencha Numero");
            camposErrados.push("Numero");
        } else {
            setNumeroErro(false);
        }

        if (bairro === '') {
            setBairroErro(true);
            setBairroErroTexto("Por favor preencha Bairro");
            camposErrados.push("Bairro");
        } else if (bairro.length < 2) {
            setBairroErro(true);
            setBairroErroTexto("Bairro deve ter no mínimo 2 Dígitos");
            camposErrados.push("Bairro");
        } else {
            setBairroErro(false);
        }

        if (codigoCidade === '') {
            setCidadeErro(true);
            setCidadeErroTexto("Por favor preencha Cidade");
            camposErrados.push("Cidade");
        } else {
            setCidadeErro(false);
        }

        if (email !== '') {
            if (validaEmail(email)) {
                setEmailErro(false);
            } else {
                setEmailErro(true);
                setEmailErroTexto("Por favor preencha um E-mail valido");
                camposErrados.push("E-mail");
            }

        } else {
            setEmailErro(false);
        }

        if (tipoPessoa === '') {
            setTipoPessoaErro(true);
            setTipoPessoaErroTexto("Por favor preencha Tipo Pessoa");
            camposErrados.push("Tipo de Pessoa");
        } else {
            setTipoPessoaErro(false);
        }

        if (tipoIe === '') {
            setTipoIeErro(true);
            setTipoIeErroTexto("Por favor preencha Tipo de Inscrição Estadual");
            camposErrados.push("Tipo de IE");
        } else {
            setTipoIeErro(false);
        }


        if (camposErrados.length === 0) {
            return true;
        } else {
            return false;
        }

    };

    return (

        <Container className={classes.corDoFundo} alignItens="center" justifyContent="center">

            <Typography
                variant="h1"
                component="h1"
                gutterBottom
                align="center"
                color="primary"
                className={classes.controlaTitulo}
            >
                Cadastro de Pessoa
            </Typography>

            <Paper className={classes.controlaCard}>
                <form>

                    <Grid container>

                        <FormControl variant="outlined"
                            className={classes.formControl}>

                            <InputLabel ref={inputLabel}>
                                Tipo Pessoa
                            </InputLabel>

                            <Select
                                error={tipoPessoaErro}
                                helperText={tipoPessoaErroTexto}
                                value={tipoPessoa}
                                onChange={handleChange}
                                labelWidth={labelWidth}
                            >
                                <MenuItem value={'F'}>Física</MenuItem>
                                <MenuItem value={'J'}>Jurídica</MenuItem>
                                <MenuItem value={'E'}>Estrangeira</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl variant="outlined"
                            className={classes.formControl}>

                            <InputLabel ref={inputLabelIE}>
                                Tipo Iscrição Estadual
                            </InputLabel>

                            <Select
                                value={tipoIe}
                                error={tipoIeErro}
                                helperText={tipoIeErroTexto}
                                onChange={handleChangeIE}
                                labelWidth={labelWidthIE}
                            >
                                <MenuItem value={1}>1 - Contribuinte ICMS</MenuItem>
                                <MenuItem value={2}>2 - Contribuinte Isento</MenuItem>
                                <MenuItem value={9}>9 - Não Contribuinte</MenuItem>
                            </Select>
                        </FormControl>

                        <CampoTextoAjuda
                            ref={refCNPJ}
                            className={tipoPessoa === 'J' ? classes.textField : classes.ocultaCampo}
                            label="CNPJ"
                            error={cnpjErro}
                            helperText={cnpjErroTexto}
                            value={cnpj}
                            onChange={e => setCnpj(e.target.value)}
                            tituloAjuda="CNPJ"
                            textoAjuda="Cadastro Nacional de Pessoa Jurídica,  Informar o CNPJ da empresa a ser cadastrada."
                            saibaMais={{
                                categoria: 'pessoa',
                                campo: 'cnpj'
                            }}
                            InputProps={{
                                inputComponent: MascaraCNPJ,
                            }}
                        />

                        <CampoTextoAjuda
                            className={tipoPessoa === 'F' ? classes.textField : classes.ocultaCampo}
                            label="CPF"
                            error={cpfErro}
                            helperText={cpfErroTexto}
                            value={cpf}
                            onChange={e => setCpf(e.target.value)}
                            tituloAjuda="CPF"
                            textoAjuda="Cadastro Pessoa Física, Informar o CPF da pessoa a ser cadastrada."
                            saibaMais={{
                                categoria: 'pessoa',
                                campo: 'cpf'
                            }}
                            InputProps={{
                                inputComponent: MascaraCPF,
                            }}
                        />

                        <CampoTextoAjuda
                            className={tipoPessoa === 'E' ? classes.textField : classes.ocultaCampo}
                            label="Passaporte"
                            error={passaporteErro}
                            helperText={passaporteErroTexto}
                            value={passaporte}
                            onChange={e => setPassaporte(e.target.value)}
                            tituloAjuda="Passaporte"
                            textoAjuda="Informar o número do passaporte da pessoa a ser cadastrada."
                            saibaMais={{
                                categoria: 'pessoa',
                                campo: 'passaporte'
                            }}

                        />

                        <CampoTextoAjuda
                            className={tipoPessoa !== 'E' ? (tipoIe != 1 ? classes.ocultaCampo : classes.textField) : classes.ocultaCampo}
                            label="Inscrição Estadual"
                            error={ieErro}
                            helperText={ieErroTexto}
                            value={ie}
                            onChange={e => setIe(e.target.value)}
                            tituloAjuda="Inscrição Estadual"
                            textoAjuda="Informar a inscrição estadual da empresa a ser cadastrada."
                            saibaMais={{
                                categoria: 'pessoa',
                                campo: 'inscricao-estadual'
                            }}

                        />

                        <CampoTextoAjuda
                            className={classes.textField}
                            label={labelNome}
                            error={fantasiaErro}
                            helperText={fantasiaErroTexto}
                            value={fantasia}
                            onChange={e => setFantasia(e.target.value)}
                            tituloAjuda={labelNome == 'Nome' ? 'Nome Completo' : 'Nome Fantasia'}
                            textoAjuda={labelNome == 'Nome' ? 'Informar o nome da pessoa que irá ser impresso na nota.' : 'Informar o nome fantasia da empresa a ser cadastrada.'}
                            saibaMais={labelNome == 'Nome' ? {
                                categoria: 'pessoa',
                                campo: 'nome'
                            } : {
                                categoria: 'pessoa',
                                campo: 'fantasia'
                            }}
                        />

                        <CampoTextoAjuda
                            className={tipoPessoa === 'J' ? classes.textField : classes.ocultaCampo}
                            label="Razão"
                            error={razaoErro}
                            helperText={razaoErroTexto}
                            value={razao}
                            onChange={e => setRazao(e.target.value)}
                            tituloAjuda="Razão Social"
                            textoAjuda="Informar a razão social da empresa a ser cadastrada."
                            saibaMais={{
                                categoria: 'pessoa',
                                campo: 'razao-social'
                            }}

                        />

                        <Paper variant="outlined" className={classes.endereco}>
                            <Typography
                                variant="h5"
                                component="h5"
                                color="primary"
                                className={classes.tituloTexto}
                            >
                                Endereço
                            </Typography>

                            <CampoTextoAjuda
                                className={classes.textField}
                                label="CEP"
                                error={cepErro}
                                helperText={cepErroTexto}
                                value={cep}
                                onChange={e => setCep(e.target.value)}
                                onBlur={e => buscarPorCep(e.target.value)}
                                tituloAjuda="CEP"
                                textoAjuda="Informar o CEP (Código de Endereçamento Postal) da empresa a ser cadastrada. Ao informar o CEP o sistema irá preencher os campos de Rua, bairro e cidade automaticamente."
                                saibaMais={{
                                    categoria: 'pessoa',
                                    campo: 'cep'
                                }}
                            />

                            <CampoTextoAjuda
                                className={classes.textField}
                                label="Número"
                                error={numeroErro}
                                helperText={numeroErroTexto}
                                value={numero}
                                onChange={e => setNumero(e.target.value)}
                                tituloAjuda="Número"
                                textoAjuda="Informar o número do endereço da ser cadastrada, caso o endereço não tenha número informar o valor SN (sem número)."
                                saibaMais={{
                                    categoria: 'pessoa',
                                    campo: 'numero'
                                }}
                            />

                            <BuscaForm
                                codigo={codigoCidade}
                                setCodigoPai={(codigoCidade) => setCodigoCidade(codigoCidade)}
                                descricao={descricaoCidade}
                                procedureConsulta="WEBSITE_LISTAGEM_GCIDADES"
                                erroTexto={cidadeErroTexto}
                                erro={cidadeErro}
                                setDescricao={setDescricaoCidade}
                                ocultaCodigo
                                // filtro="CDSPESS"
                                tabela="CIDADE"
                                label="Cidade"
                                ajuda={{
                                    obrigatorio: true,
                                    tituloAjuda: 'Cidade',
                                    textoAjuda: 'informar a cidade referente ao endereço, para informar a cidade utilize a tela de busca pressionando o botão com um ícone de lupa.',
                                    saibaMais: {
                                        categoria: 'pessoa',
                                        campo: 'cidade'
                                    }
                                }}
                            />

                            <CampoTextoAjuda
                                className={classes.textField}
                                label="Rua"
                                error={ruaErro}
                                helperText={ruaErroTexto}
                                value={rua}
                                onChange={e => setRua(e.target.value)}
                                tituloAjuda="Rua"
                                textoAjuda="Informar a rua da pessoa a ser cadastrada."
                                saibaMais={{
                                    categoria: 'pessoa',
                                    campo: 'rua'
                                }}

                            />

                            <CampoTextoAjuda
                                className={classes.textField}
                                label="Bairro"
                                error={bairroErro}
                                helperText={bairroErroTexto}
                                value={bairro}
                                onChange={e => setBairro(e.target.value)}
                                tituloAjuda="Bairro"
                                textoAjuda="Informar o bairro da pessoa a ser cadastrada."
                                saibaMais={{
                                    categoria: 'pessoa',
                                    campo: 'bairro'
                                }}
                            />

                            <CampoTextoAjuda
                                className={classes.textField}
                                label="Complemento"
                                error={complementoErro}
                                helperText={complementoErroTexto}
                                value={complemento}
                                onChange={e => setComplemento(e.target.value)}
                                obrigatorio={false}
                                tituloAjuda="Complemento"
                                textoAjuda="Campo opcional. Informar um complemento para o endereço."
                                saibaMais={{
                                    categoria: 'pessoa',
                                    campo: 'complemento'
                                }}
                            />
                        </Paper>

                        <CampoTextoAjuda
                            className={classes.textField}
                            label="E-mail"
                            error={emailErro}
                            helperText={emailErroTexto}
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            tituloAjuda="E-mail"
                            textoAjuda="Informar o e-mail da ser pessoa a ser cadastrada."
                            saibaMais={{
                                categoria: 'pessoa',
                                campo: 'e-mail'
                            }}
                        />

                        <CampoTextoAjuda
                            className={classes.textField}
                            label="Telefone"
                            error={telefoneErro}
                            helperText={telefoneErroTexto}
                            value={telefone}
                            onChange={e => setTelefone(e.target.value)}
                            tituloAjuda="Telefone"
                            textoAjuda="Informar o telefone da pessoa a ser ser cadastrada."
                            saibaMais={{
                                categoria: 'pessoa',
                                campo: 'telefone'
                            }}
                            InputProps={{
                                inputComponent: MascaraTelefone,
                            }}
                        />

                        {codigoPessoa > 0 && <Grid item xs={12} align="center">
                            <FormControlLabel
                                className={classes.formControl}
                                control={
                                    <Switch
                                        checked={ativo}
                                        onChange={e => setAtivo(e.target.checked)}
                                        name="checkedA"
                                        color="primary"
                                        inputProps={{ 'aria-label': 'Ativo' }}
                                    />
                                }
                                label="Ativo"
                            />
                        </Grid>}


                        <Grid container>
                            <Grid item xs={6} className={classes.botaoRodape}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    type="button"
                                    onClick={cancelar}
                                    fullWidth
                                >
                                    Cancelar
                                </Button>
                            </Grid>
                            <Grid item xs={6} className={classes.botaoRodape}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    onClick={salvar}
                                    fullWidth
                                >
                                    Salvar
                                </Button>
                            </Grid>
                        </Grid>

                    </Grid>
                </form>

            </Paper>

        </Container>

    )
}


export default withRouter(FormPessoa);